/**
 * Build TipTap-compatible initial document from API fields.
 * Prefer HTML ``content_text`` when present: student EssayWriter stores
 * alignment as ``style="text-align:…"`` there, while ``content_json`` may omit
 * ``textAlign`` attrs (especially after older counselor editor loads).
 * @param {object|null} contentJson — parsed JSON document or null
 * @param {string|null|undefined} contentText — HTML or plain text fallback
 * @returns {object|string}
 */
export function buildTipTapDocument(contentJson, contentText) {
	const raw = String(contentText || '')
	if (/<[a-z][\s\S]*>/i.test(raw)) {
		return raw
	}
	if (contentJson && typeof contentJson === 'object') {
		return contentJson
	}
	if (!raw.trim()) {
		return { type: 'doc', content: [{ type: 'paragraph' }] }
	}
	const escaped = raw
		.replace(/&/g, '&amp;')
		.replace(/</g, '&lt;')
		.replace(/>/g, '&gt;')
		.replace(/\n/g, '<br/>')
	return `<p>${escaped}</p>`
}

export function countWordsFromPlainText(text) {
	const t = String(text || '').trim()
	if (!t) return 0
	return t.split(/\s+/).filter(Boolean).length
}

export function plainPreviewFromHtml(html, max = 120) {
	const t = String(html || '')
		.replace(/<[^>]+>/g, ' ')
		.replace(/&nbsp;/gi, ' ')
		.replace(/&amp;/g, '&')
		.replace(/&lt;/g, '<')
		.replace(/&gt;/g, '>')
		.replace(/&quot;/g, '"')
		.replace(/&#39;/g, "'")
		.replace(/\s+/g, ' ')
		.trim()
	if (!t) return ''
	return t.length > max ? `${t.slice(0, max).trim()}…` : t
}
